export enum Direction {
  Up = 'up',
  Right = 'right',
  Down = 'down',
  Left = 'left',
}

export enum Color {
  Purple = 'purple',
  InactivePurple = 'inactivePurple',
  White = 'white',
  Charcoal = 'charcoal',
  Red = 'red',
  LightGray = 'lightgray',
  Gray = 'gray',
  DimGray = 'dimgray',
  InactiveGray = 'inactiveGray',
  LoopGray = 'loopGray',
  Black = 'black',
  Blue = 'blue',
  Green = 'green',
  Orange = 'orange',
  Yellow = 'yellow',
  Transparent = 'none',
}

export interface Size {
  width: number;
  height: number;
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/common/src/model/basics.ts